<template>
  <div id="main">

    <div id="header">
      <button type="button" class="btn btn-primary" @click="itemInfo()">棚番号 カメラ登録</button>
    </div>

    <div id="grid-table-contents">
      <div v-if="isList" class="grid-table-scroll">
        <table class="table table-striped table-sm table-hover sticky_table">
          <thead>
            <tr class="table-primary">
              <th class="col-header-shelf-number">棚番号</th>
              <th class="col-header-send">管理番号</th>
              <th class="col-header-item" @click="clickedNameTitle()">商品名</th>
              <th v-show="!isSmartPhone()">ファイル名</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rowItem, rowIndex) in items"
              v-bind:key="rowIndex"
              v-bind:id = "'list' + rowItem.json.index"
              :style="checkedRowColor(rowItem.json.shelf_id)">
              <td class="col-shelf-number">{{rowItem.json.shelf_id}}</td>
              <td class="col-send">{{rowItem.json.managed_id}}</td>
              <td class="col-item">{{itemShow(rowItem.json.title)}}</td>
              <td v-show="!isSmartPhone()">{{rowItem.json.zip}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <span v-if="apiComplete">今日のデータをアップロードしてください</span>
        <span v-else class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import isSmartPhone from '@/js/isSmartPhone.js'

export default defineComponent({
  setup () {
    const router = useRouter()
    const items = ref([])
    const apiComplete = ref(false)
    const sendIndex = ref(-1)
    const shortName = ref(true)
    const filterIndex = ref(sendIndex.value)

    const setListItems = () => {
      apiComplete.value = false
      axios.get('/api/putup/get_item_records')
        .then((res) => {
          items.value = res.data.records
          console.log(res.data.records)
        })
    }

    onMounted(() => {
      setListItems()
    })

    // Listデータの有無
    const isList = computed(() => {
      return items.value.length > 0
    })

    // 行の色
    const checkedRowColor = (shelfId) => {
      let rtn = {}
      if (shelfId !== '') {
        rtn = { background: '#c6efce' }
      }
      return rtn
    }

    // 商品名の文字数
    const itemShow = (buf) => {
      let rtn = buf
      if (shortName.value && buf.length > 30) {
        rtn = rtn.substr(0, 30) + '…'
      }
      return rtn
    }

    const itemInfo = () => {
      router.push({ name: 'PutupChecker' })
    }

    const clickedNameTitle = () => {
      shortName.value = !shortName.value
    }

    const changeSendSelect = () => {
      setListItems()
    }

    return {
      filterIndex,
      items,
      apiComplete,
      isList,
      checkedRowColor,
      itemShow,
      itemInfo,
      changeSendSelect,
      clickedNameTitle,
      isSmartPhone
    }
  }
})
</script>
<style lang="scss" scoped>
#main {
  position: relative;
  height: 100%;
  width: 100%;

  #header {
    position: relative;
    top: 1.5rem;
    height: 25%;
    width: 100%;
  }

  #grid-table-contents {
    position: absolute;
    bottom : 10%;
    height: 75%;
    width: 100%;

    .grid-table-scroll {
      overflow-y: scroll;
      height: 100%;
      width: 100%;
      font-size: medium;

      .sticky_table {
        width: 100%;
        white-space: nowrap;

        thead th {
          /* 縦スクロール時に固定する */
          position: sticky;
          top: 0;
          /* tbody内のセルより手前に表示する */
          z-index: 1;
        }
        td.col-item {
          text-align: left;
          white-space: nowrap;
        }
        td.col-send {
          white-space: nowrap;
        }
        td.col-shelf-number {
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
